import * as React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import FeePayment from './FeePayment';
import StorePurchase from './StorePurchase';
import StorePayment from './StorePayment';
import TransportPayment from './TransportPayment';
import AnnualSubscription from './AnnualSubscription';
import Refund from './Refund';
import InventoryRefund from './InventoryRefund';
import PaymentSummary from './PaymentSummary';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useLocation } from 'react-router-dom';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FeesManagementTabs() {
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setOpen(false);
  }



  return (
    <Dialog onClose={handleClose} maxWidth='xl' fullWidth  open={open}>
      <DialogTitle></DialogTitle>
      <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      <Box sx={{ width: 'auto' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Fee Payment" {...a11yProps(0)} />
            <Tab label="Store Purchase" {...a11yProps(1)} />
            <Tab label="Store Payment" {...a11yProps(2)} />
            <Tab label="Transport Payment" {...a11yProps(3)} />
            <Tab label="Annual Subscription" {...a11yProps(4)} />
            <Tab label="Refund" {...a11yProps(5)} />
            <Tab label="Inventory Refund" {...a11yProps(6)} />
            <Tab label="Payment Summary" {...a11yProps(7)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <FeePayment />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <StorePurchase />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <StorePayment />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <TransportPayment />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <AnnualSubscription />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
          <Refund />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={6}>
          <InventoryRefund />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={7}>
          <PaymentSummary />
        </CustomTabPanel>
      </Box>
    </Dialog>
  );
}